import { useParams } from 'react-router-dom'
import { useMountpointInfo } from '../api'

import { MenuItem } from './MenuItem'
import Typography from '@material-ui/core/Typography'

import SettingsIcon from '@material-ui/icons/Settings'
import { CloseIcon, LogsIcon, StatsIcon } from '../icons'
// import HistoryIcon from '@material-ui/icons/History'
// import TimelineIcon from '@material-ui/icons/Timeline'
// import BarChart from '@material-ui/icons/BarChart'

import { strings } from '../strings'

export function MountpointMenu() {
  const { mid } = useParams<any>()
  const { mountpointInfo } = useMountpointInfo(mid)

  return (
    <>
      <MenuItem route="/mountpoints" icon={CloseIcon} />
      <Typography style={{ fontSize: 14, color: '#fff', flexGrow: 1 }}>
        {strings.mountpoint} {mountpointInfo?.name}
      </Typography>
      <MenuItem route={`/mountpoint/:mid/info`} icon={SettingsIcon} />
      {/*<MenuItem route={`/mountpoint/:mid/satellites`} icon={BarChart} />*/}
      {/*<MenuItem route={`/mountpoint/:mid/satellites-count`} icon={HistoryIcon} />*/}
      {/*<MenuItem route={`/mountpoint/:mid/satellite-signals`} icon={TimelineIcon} />*/}
      <MenuItem route={`/mountpoint/:mid/stats`} icon={StatsIcon} />
      <MenuItem route={`/mountpoint/:mid/logs`} icon={LogsIcon} />
    </>
  )
}
